import { jsx as _jsx } from "react/jsx-runtime";
import { Shell } from './Shell.js';
import { MobileShell } from './MobileShell.js';
import { useMediaQuery } from './useMediaQuery.js';
/**
 * Renders the mobile shell on narrow viewports and the laptop shell otherwise — both have full
 * functional parity (D-062). The breakpoint mirrors the prototype's fold point.
 */
export function ResponsiveShell(props) {
    const isMobile = useMediaQuery('(max-width: 760px)');
    return isMobile ? _jsx(MobileShell, { ...props }) : _jsx(Shell, { ...props });
}
//# sourceMappingURL=ResponsiveShell.js.map